//
//
//
//
//
//
//
//
import Clipboard from '@tencent/vft-common/clipboard';
export default {
  methods: {
    copy: function copy() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this; // eslint-disable-next-line no-new

      new Clipboard({
        text: '腾讯体育VIP',
        success: function success() {
          self.toast('已复制，快去微信粘贴搜索吧~');
        },
        error: function error() {
          self.toast('暂不支持复制功能，可手动搜索【腾讯体育VIP】！');
        }
      });
    }
  }
};